import { observer } from 'mobx-react-lite';
import { AnimatePresence, motion } from 'motion/react';
import { useEffect, useRef } from 'react';

import { Icons } from '@/assets/icons/icons';
import { IconButton } from '@/components/ui';
import { tabStore, useTabs } from '@/features/tabs';

import { birdGameStore } from './bird-game.store';
import { BirdFlightOverlay } from './BirdFlightOverlay';
import { BirdGameStage } from './BirdGameStage';
import { useBirdGame } from './use-bird-game';

export const BirdGameView = observer(function BirdGameView() {
  const { closeTab } = useTabs();
  const controller = useBirdGame();
  const { phase } = birdGameStore;
  const isStageMounted = phase === 'flying-in' || phase === 'open';

  const ownerTabIdRef = useRef<string | null>(null);
  useEffect(() => {
    ownerTabIdRef.current = tabStore.activeTabId;
  }, []);

  const dismiss = () => {
    const ownerTabId = ownerTabIdRef.current;
    if (ownerTabId) closeTab(ownerTabId);
  };

  return (
    <div className="shell-tint relative size-full overflow-hidden">
      <AnimatePresence>
        {isStageMounted && (
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.15 }}
            className="absolute inset-0 flex overflow-hidden"
            data-testid="bird-game-view"
          >
            <BirdGameStage controller={controller} />
            {phase === 'open' && (
              <IconButton
                size="sm"
                variant="secondary"
                className="absolute right-3 top-3 z-20 bg-secondary-active"
                icon={Icons.cancel}
                tooltip="Close"
                aria-label="Close Flight Mode"
                onClick={controller.leaveGame}
              />
            )}
          </motion.div>
        )}
      </AnimatePresence>
      <BirdFlightOverlay controller={controller} onFlyOutArrive={dismiss} />
    </div>
  );
});
